<table class="ui selectable celled table">
  <thead>
  <tr>
    <th i18n="@@title">Titel</th>
    @if (showSaved) {
      <th i18n="@@internal-messages-saved">Gesichert</th>
    }
    @if (showPlanned) {
      <th i18n="@@internal-messages-planed">Eingeplant für Versand am {{ sendingDate | date }}</th>
    }
    @if (actions) {
      <th i18n="@@internal-messages-actions">Aktionen</th>
    }
  </tr>
  </thead>
  <tbody>
    @for (internalMessage of internalMessages; track internalMessage) {
      <tr>
        <td>
          {{ internalMessage.title }}
        </td>
        @if (showSaved) {
          <td>
            <i [class]="internalMessage.saved ? 'check icon' : 'times icon'"></i>
          </td>
        }
        @if (showPlanned) {
          <td>
            <i [class]="internalMessage.readyToSend ? 'check icon' : 'times icon'"></i>
          </td>
        }
        @if (actions) {
          <td>
            @if (!internalMessage.sent) {
              <button class="ui primary icon button"
                      data-tooltip="Senden" i18n-data-tooltip="@@internal-messages-send"
                      (click)="send(internalMessage)">
                <i class="send icon"></i>
              </button>
              @if (internalMessage.readyToSend) {
                <button class="ui secondary icon button"
                        data-tooltip="Versand abbrechen" i18n-data-tooltip="@@internal-messages-cancel"
                        (click)="setSend(internalMessage, false)">
                  <i class="cancel icon"></i>
                </button>
              } @else {
                <button class="ui secondary icon button"
                        data-tooltip="Versand planen" i18n-data-tooltip="@@internal-messages-plan"
                        (click)="setSend(internalMessage, true)">
                  <i class="paper plane outline icon"></i>
                </button>
              }
            }
            <button class="ui primary icon button" data-tooltip="Bearbeiten" (click)="edit(internalMessage)"
                    i18n-data-tooltip="@@internal-messages-edit">
              <i class="edit icon"></i>
            </button>
            <button class="ui red icon button" data-tooltip="Löschen" (click)="delete(internalMessage)"
                    i18n-data-tooltip="@@internal-messages-delete">
              <i class="trash icon"></i>
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
